import React from "react";

const PageFilter = ({ children }) => {
  return (
    <div
      id='page_filter'
      className='mb-2 p-4 shadow-md bg-white border border-gray-300'
    >
      {children}
    </div>
  );
};

export default PageFilter;
